export default {
    path: 'recharge',
    component: () => import(/* webpackChunkName: "recharge" */ '@/pages/recharge/index'),
    meta: {title:'预充值管理'}
}